import { useState, useEffect } from "react";

const CHANNELS = [
  { emoji: "📸", label: "Instagram" },
  { emoji: "𝕏", label: "X / Twitter" },
  { emoji: "📘", label: "Facebook" },
  { emoji: "📧", label: "Email" },
];

export default function ShareYourLink(): JSX.Element {
  const [copied, setCopied] = useState(false);
  const [views, setViews] = useState(24);
  const [entries, setEntries] = useState(7);

  useEffect(() => {
    // Copy animation loop
    const copyLoop = setInterval(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    }, 3200);

    // Increment counters
    const counter = setInterval(() => {
      setViews(v => v + Math.floor(Math.random() * 2) + 1);
      if (Math.random() > 0.5) setEntries(e => e + 1);
    }, 1800);

    return () => {
      clearInterval(copyLoop);
      clearInterval(counter);
    };
  }, []);

  return (
    <div style={{
      width: "100%", maxWidth: 400, height: "auto", minHeight: 200, aspectRatio: "3/2", overflow: "hidden",
      background: "#fff", borderRadius: 14,
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: "flex", flexDirection: "column",
    }}>
      {/* Header */}
      <div style={{
        background: "#f8fafc", borderBottom: "1px solid #e2e8f0",
        padding: "10px 14px", display: "flex",
        alignItems: "center", justifyContent: "space-between",
        flexShrink: 0,
      }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>
          🔗 Share Your Contest
        </span>
        <span style={{
          fontSize: 10, fontWeight: 600, color: "#22c55e",
          background: "rgba(34,197,94,0.08)",
          padding: "2px 8px", borderRadius: 20,
          display: "flex", alignItems: "center", gap: 4,
        }}>
          <span style={{ fontSize: 7 }}>●</span> Live
        </span>
      </div>

      {/* Body */}
      <div style={{ padding: "12px 14px", flex: 1 }}>
        {/* Link row */}
        <div style={{
          display: "flex", alignItems: "center", gap: 8,
          background: "#f8fafc", border: `1px solid ${copied ? "#0d9488" : "#e2e8f0"}`,
          borderRadius: 8, padding: "7px 10px", marginBottom: 8,
          transition: "border-color 0.3s, box-shadow 0.3s",
          boxShadow: copied ? "0 0 0 3px rgba(13,148,136,0.1)" : "none",
        }}>
          <span style={{
            fontSize: 11, color: "#64748b", flex: 1,
            fontFamily: "monospace", overflow: "hidden",
            textOverflow: "ellipsis", whiteSpace: "nowrap",
          }}>
            rafflekit.app/c/summer-giveaway
          </span>
          <div style={{
            background: copied ? "#0d9488" : "#0f172a",
            color: "#fff", fontSize: 10, fontWeight: 700,
            padding: "4px 10px", borderRadius: 6,
            transition: "background 0.25s",
            flexShrink: 0, minWidth: 48, textAlign: "center",
          }}>
            {copied ? "✓ Done" : "Copy"}
          </div>
        </div>

        {/* Share channels */}
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr",
          gap: 5, marginBottom: 8,
        }}>
          {CHANNELS.map((ch, i) => (
            <div key={i} style={{
              display: "flex", flexDirection: "column",
              alignItems: "center", gap: 4,
              padding: "6px 8px",
              background: "#f8fafc", border: "1px solid #e2e8f0",
              borderRadius: 8, cursor: "pointer",
            }}>
              <span style={{ fontSize: 15 }}>{ch.emoji}</span>
              <span style={{ fontSize: 9, fontWeight: 600, color: "#64748b" }}>
                {ch.label}
              </span>
            </div>
          ))}
        </div>

        {/* Live stats */}
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr",
          gap: 8,
        }}>
          {[
            { label: "Page Views", value: views, color: "#0d9488" },
            { label: "Entries so far", value: entries, color: "#f97316" },
          ].map((s, i) => (
            <div key={i} style={{
              background: "#f8fafc", border: "1px solid #e2e8f0",
              borderRadius: 8, padding: "8px 12px",
            }}>
              <div style={{
                fontSize: 18, fontWeight: 800, color: s.color,
                transition: "all 0.2s",
              }}>{s.value}</div>
              <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 1 }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
